/**
 * 深度拷贝
 * @author chentong
 * @date 2023-02-24
 */

import {
  isArray,
  isBoolean,
  isFunction,
  isNull,
  isNumber,
  isObject,
  isString,
} from './utils';

/**
 * 深度拷贝对象
 * @param from
 * @param to
 * @returns
 */
export function deepCopy(from: any, to: any) {
  if (isNull(from)) return;
  if (isNull(to)) return;
  if (!isObject(from) || !isObject(to)) return;

  Object.entries(from).forEach(([key, val]) => {
    if (!isNull(val)) {
      //当是基础数据类型时
      if (isFunction(val) || isString(val) || isNumber(val) || isBoolean(val)) {
        Reflect.set(to, key, val);
      } else if (isArray(val)) {
        let toArr: any[] = [];
        copyArray(val as [], toArr);
        Reflect.set(to, key, toArr);
      } else if (isObject(val)) {
        let toObj = {};
        deepCopy(val, toObj);
        Reflect.set(to, key, toObj);
      }
    }
  });
}

/**
 * 深度拷贝数组
 * @param from
 * @param to
 * @returns
 */
export function copyArray(fromArr: any[], toArr: any[]) {
  if (isNull(fromArr) || isNull(toArr)) return;

  fromArr.forEach((element, index) => {
    if (
      isFunction(element) ||
      isString(element) ||
      isNumber(element) ||
      isBoolean(element)
    ) {
      //基础数据类型 直接拷贝
      toArr.push(element);
    } else if (isArray(element)) {
      //数组类型 递归调用
      var targetArr: Array<any> = new Array();
      copyArray(element, targetArr);
      toArr.push(targetArr);
    } else if (isObject(element)) {
      //对象类型拷贝
      const targetObj = {};
      deepCopy(element, targetObj);
      toArr.push(targetObj);
    }
  });
}
